import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as toastr from 'toastr';

import paymentActions from '../../payment/paymentActions';
import userActions from '../../user/userActions';

import FailedPaymentDetails from './FailedPaymentDetails';
import FailedPaymentUserDetails from './FailedPaymentUserDetails';
import PaymentDetailsForm from '../../payment/PaymentDetailsForm';
import { Button } from '../../components/buttons';
import { Page, PageContent, PageHeader } from '../../components/common';
import { SecurityRoles } from '../../common/utils';
import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';

interface Props {
	actions: any;
	history: any;
	match: any;
	details: any;
	payment: PaymentHistory;
	stripe: any;
	user: UserDetails;
}
interface State {
	isPaymentLoading: boolean;
}
class FailedPaymentDetailsPage extends React.Component<Props, State> {
	state = {
		isPaymentLoading: false
	};

	componentDidMount() {
		this.props.actions
			.fetchPayment(this.props.match.params.id)
			.then(() => this.props.actions.fetchUserByPolicyId(this.props.payment.policyId));
	}

	makePayment = () => {
		this.setState({ isPaymentLoading: true });
		this.props.stripe
			.createToken({ name: this.props.details.ccCardholderName })
			.then((result: any) => {
				if (result.error) {
					toastr.error(result.error.message);
				} else {
					// Send the token to server
					return this.props.actions.payInvoice(this.props.payment.stripeInvoiceId, result.token).then(() => {
						toastr.success('Payment sent!');
					});
				}
			})
			.then(() => this.setState({ isPaymentLoading: false }));
	}

	render() {
		return (
			<Page title="Failed payments">
				<PageContent>
					<PageHeader title="Failed payments" className="page-header-sm" />
					<div className="row">
						<FailedPaymentDetails className="col-md-6 mb-4" payment={this.props.payment} />
						<FailedPaymentUserDetails className="col-md-6" user={this.props.user} />
					</div>
					<div className="form-fieldset">
						<PaymentDetailsForm actions={this.props.actions} details={this.props.details} />
					</div>
					<Button
						className="btn-primary mt-4"
						type="button"
						onClick={this.makePayment}
						disabled={this.state.isPaymentLoading}
					>
						Retry payment
					</Button>
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		details: state.payment.details,
		payment: state.payment.payment,
		stripe: state.payment.stripe,
		user: state.user.user
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...paymentActions, ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(FailedPaymentDetailsPage);
const roles = [SecurityRoles.Administrator, SecurityRoles.Agent];
export default ensureUserHasRoleAdminSite(connectedPage as any, roles);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/reports/FailedPaymentDetailsPage.tsx